import * as reportActions from './actions';
import * as loginActions from '../login/actions';
import {Record, fromJS, Map} from 'immutable';
import {prepareOrderObject, countTotalItemsPrice, countVatsItesPrices, mapVat} from '../lib/util';

const State = Record({
    dailySum: null,
    printDailySum: false,
    reportOpen: false,
    openCloseReportPanel: false
});

const DAILY_SUM = 'dailySum';
const PRINT_DAILY_SUM = 'printDailySum';
const REPORT_OPEN = 'reportOpen';
const OPEN_CLOSE_REPORT_PANEL = 'openCloseReportPanel';

const reportReducer = (state = new State(), action) => {

    switch (action.type) {

        case reportActions.OPEN_CLOSE_REPORT_PANEL: {
            return state.set(OPEN_CLOSE_REPORT_PANEL, true);
        }

        case reportActions.CLOSE_CLOSE_REPORT_PANEL: {
            return state.set(OPEN_CLOSE_REPORT_PANEL, false);
        }

        case reportActions.SET_REPORT_IS_OPEN: {
            return state.set(REPORT_OPEN, action.payload.open);
        }

        case loginActions.API_LOGOUT: {
            return state
                .set(OPEN_CLOSE_REPORT_PANEL, false)
                .set(REPORT_OPEN, false);
        }

        case reportActions.OPEN_BAR_REPORT_SUCCESS: {
            return state.set(REPORT_OPEN, true)
        }

        case reportActions.FETCH_IS_BAR_REPORT_OPEN_SUCCESS: {
            return state.set(REPORT_OPEN, action.payload.data)
        }

        case reportActions.CLOSE_PRINT_DAILY_SUM: {
            return state.set(PRINT_DAILY_SUM, false);
        }

        case reportActions.FETCH_DAILY_REPORT_SUM_START: {
            return state.set(PRINT_DAILY_SUM, true);
        }

        case reportActions.FETCH_DAILY_REPORT_SUM_SUCCESS: {
            const {items, vats, report, cashboxes} = action.payload.data;
            let sum = manageDailySum(fromJS(items), vats);
            sum = sum.set('report', fromJS(report));
            sum = sum.set('cashboxesSums', fromJS(cashboxes));
            return state.set(DAILY_SUM, sum);
        }

    }

    return state;
};

export default reportReducer;

function manageDailySum(items, vats) {
    let vatsMap = Map();
    vats.map(vat => {
        vatsMap = vatsMap.set(vat.id, mapVat(vat));
    });

    const reportItems = fromJS(manageItemsToDailySum(items));
    return prepareOrderObject(
        null,
        reportItems,
        countTotalItemsPrice(reportItems),
        countVatsItesPrices(vatsMap, reportItems),
        null, null, null, false, 0, null, null
    );
}

function manageItemsToDailySum(items) {
    return items.filter(item => item.get(1) > 0).map(item => {
        return Map({
            pcs: item.get(1),
            name: item.get(0),
            price: item.get(2) / item.get(1),
            vatId: item.get(3),
            discount: 0
        })
    });
}



// WEBPACK FOOTER //
// ./src/common/report/reducer.js